module.exports = __webpack_public_path__ + "img/20190924154412360截图20190924150119816.2edefde2.jpg";